import { CreateItemDto, Item } from "../../types/item.types";
import { PaginationInputDto } from "../../model/common/PaginatedInputDto";
import { get, post, del } from "../../utils/BaseService";

export async function getAllItems(dispatch: any, props: PaginationInputDto) {
  return await post(dispatch, '/items/getAllItems', props);
}

export async function getActiveItems(dispatch: any) {
  return await get(dispatch, '/items/getActiveItems', null);
}

export async function getItemById(dispatch: any, id: string) {
  return await get(dispatch, `/items/getItemById/${id}`, null);
}

export async function createItem(dispatch: any, props: CreateItemDto[]) {
  return await post(dispatch, "/items/createItem", props);
}

export async function updateItem(dispatch: any, id: number, props: Partial<Item>) {
  return await post(dispatch, `/items/updateItem/${id}`, props);
}

export async function deleteItem(dispatch: any, id: number) {
  return await del(dispatch, `/items/deleteItem`, id);
}